import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { getBackendUrl } from './get-backend-url';

const BACKEND_ROUTE = getBackendUrl();

type GetInstructionsHtmlOpts = {
  instructionsLink: string | null;
};

export const getInstructionsHtml = async (opts: GetInstructionsHtmlOpts) => {
  const response = await axios.post(
    `${BACKEND_ROUTE}/auth/instructions-html`,
    opts,
  );

  return response.data;
};

export const useInstructionsHtml = ({
  instructionsLink,
}: GetInstructionsHtmlOpts) => {
  const query = useQuery({
    queryKey: ['instructions-html', instructionsLink],
    queryFn: async () => {
      if (!instructionsLink) return null;

      const url = new URL(instructionsLink);
      const hostname = url.hostname;
      const response = await getInstructionsHtml({ instructionsLink });

      return response.html?.replace(
        /(src|href)="(?!http)/g,
        `$1="https://${hostname}`,
      );
    },
    refetchOnWindowFocus: false,
    enabled: !!instructionsLink,
  });

  return { ...query, html: query.data };
};
